import { render, staticRenderFns } from "./DashSideNav.vue?vue&type=template&id=7311daf8&"
import script from "./DashSideNav.vue?vue&type=script&lang=js&"
export * from "./DashSideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports